import { AnyPromotionInfo, DataResponse } from '../models';
import { ceV2Axios } from './axios';

export const getActivePromotion = async (): Promise<AnyPromotionInfo | null> => (
  await ceV2Axios.get<DataResponse<AnyPromotionInfo | null>>('/promotion/active', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data;

/**
 * Every SINGLE_PRODUCT campaign the account is still eligible for. Several campaigns now run in
 * parallel (one per Starter SKU), so each card prices itself with its OWN campaign; `/active`
 * only ever answers the first one and stays for older clients (A.15.2 / B.8).
 */
export const getActiveCampaigns = async (): Promise<AnyPromotionInfo[]> => (
  await ceV2Axios.get<DataResponse<AnyPromotionInfo[]>>('/promotion/active-campaigns', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })
).data.data ?? [];

export const checkStarterPackage = async (
  { accountId, spEnabled }: { accountId: number, spEnabled: boolean },
) => (
  await ceV2Axios.get<DataResponse<boolean>>(`/promotion/starter-package/${accountId}/check`, {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {
      spEnabled,
    },
    data: {},
  })
).data.data;

export const checkFirstThreeLicenses = async () => (
  await ceV2Axios.get<DataResponse<boolean>>('/promotion/first-three-licenses/check', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: {},
    data: {},
  })
).data.data;
